import React, { useCallback, useEffect } from "react";
import { Form, Input, Row, Col } from "antd";
import { showJiraWidget } from "@/utils/utils";
import { Validator } from "@/utils/validator";
import { createPrice, updatePrice } from "@/services/nissanPrices";

export default function NissanPriceForm({
  formRef,
  initialValues,
  refreshTable,
  setVisible,
  editMode = false,
  setLoading,
}) {
  useEffect(() => {
    formRef?.resetFields();
    formRef?.setFieldsValue(initialValues);
  }, [initialValues, formRef]);

  const onSubmit = useCallback(
    values => {
      setLoading(true);

      const apiCaller = editMode ? updatePrice : createPrice;

      apiCaller(values)
        .then(() => {
          formRef?.resetFields();
          setVisible(false);
          if (typeof refreshTable === "function") {
            refreshTable();
          }

          showJiraWidget();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [refreshTable, editMode, setVisible, setLoading, formRef],
  );

  return (
    <Form form={formRef} layout="vertical" initialValues={initialValues} onFinish={onSubmit}>
      <Row>
        <Col lg={12}>
          <Form.Item name="miles" label="Miles" rules={[Validator.required("Please input miles")]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={12}>
          <Form.Item name="originCity" label="Origin City" rules={[Validator.required("Please input origin city")]}>
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item name="originState" label="Origin State" rules={[Validator.required("Please input origin state")]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={12}>
          <Form.Item
            name="destinationCity"
            label="Destination City"
            rules={[Validator.required("Please input destination city")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item
            name="destinationState"
            label="Destination State"
            rules={[Validator.required("Please input destination state")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={8}>
          <Form.Item
            name="aDealerPrice"
            label="A Dealer Price"
            rules={[Validator.required("Please input a dealer price")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={8}>
          <Form.Item
            name="bDealerPrice"
            label="B Dealer Price"
            rules={[Validator.required("Please input b dealer price")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={8}>
          <Form.Item
            name="cDealerPrice"
            label="C Dealer Price"
            rules={[Validator.required("Please input c dealer price")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={8}>
          <Form.Item
            name="aTransporterPrice"
            label="A Transporter Price"
            rules={[Validator.required("Please input a transporter price")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={8}>
          <Form.Item
            name="bTransporterPrice"
            label="B Transporter Price"
            rules={[Validator.required("Please input b transporter price")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={8}>
          <Form.Item
            name="cTransporterPrice"
            label="C Transporter Price"
            rules={[Validator.required("Please input c transporter price")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
    </Form>
  );
}
